import fetch from 'isomorphic-fetch';

const ENDPOINT_URL = process.env.VUE_APP_OBTENER_PLANILLA_POR_PERIODO_Y_TIPO;
async function getPlanillaPorPeriodoYPorTipo(periodo, tipo_proceso) {
  const bodyParams = {
    periodo,
    tipo_proceso,
    token: localStorage.getItem('token'),
  };

  let body = JSON.stringify(bodyParams);

  return await fetch(ENDPOINT_URL, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    body,
  }).then((item) => item.json());
}
export { getPlanillaPorPeriodoYPorTipo };
